import React, { useState, useEffect, Fragment } from 'react'
import { convertToCurrency } from '@utils/utils.js'

const Price = ({ product, priceType, matchingVariants, variantIdOnLoad }) => {
    if (priceType === 'quickBuy') {
        // console.log('product in Price.jsx', product)
    }

    // console.log('product in Price.jsx', product)

    const invalidProductTypes = [
        'Gift Cards',
        'Gift Card',
        'Specialty SKU',
        'Embroidery Option',
        'Embroidery',
        'Virtual Classes',
        'Classes + Events',
        'Classes',
    ]

    let is10Off = false
    let is20Off = false
    let is25Off = false
    let is30Off = false
    let is40Off = false
    let is50Off = false
    let is60Off = false
    let is70Off = false
    let isDoorbuster = false
    let is40OffDresses = false
    let isHeartsCollection = false
    let isUppababySale = false
    let isDisney = false

    const tags = product?.tags
    const vendor = product?.vendor || 'Monica + Andy'
    const productType = product?.product_type

    // console.log('productType', productType)

    const isInvalidProductType = invalidProductTypes.includes(productType)

    // console.log('isInvalidProductType', isInvalidProductType)

    const variants = product?.variants

    //

    let firstVariantWithInventory

    if (tags?.includes('uppababysale')) {
        isUppababySale = true
    }

    if (vendor === 'Monica + Andy' && !isInvalidProductType) {
        firstVariantWithInventory = variants?.find(
            (variant) => variant?.inventory_quantity > 0
        )
        if (
            (tags && tags?.includes('fallhalloween2024')) ||
            tags?.includes('halloween')
        ) {
            is50Off = true
        }
        if (tags?.includes('doorbuster2024')) {
            isDoorbuster = true
        }
        if (tags?.includes('dressesvday40')) {
            is40OffDresses = true
        }
        if (tags?.includes('vday2024')) {
            isHeartsCollection = true
        }
        if (tags?.includes('disney')) {
            isDisney = true
        } else {
            isDisney = false
        }

    } else if (
        matchingVariants &&
        matchingVariants.length > 0 &&
        !isInvalidProductType
    ) {
        firstVariantWithInventory = matchingVariants
            ? matchingVariants[0]
            : variants[0]
    } else if (variantIdOnLoad) {
        firstVariantWithInventory = variants?.find(
            (variant) => variant?.id?.toString() === variantIdOnLoad?.toString()
        )
    } else if (!isInvalidProductType) {
        firstVariantWithInventory = variants[0]
    }

    //

    const [price, setPrice] = useState({})

    const [discountPercent, setDiscountPercent] = useState(0)

    useEffect(() => {
        const roundIfNeeded = (price) => {
            // console.log('price in roundIfNeeded', price)
            const decimal = price % 1
            const firstDecimal = Math.floor((decimal * 10) % 10)
            const secondDecimal = Math.floor((decimal * 100) % 10)
            const thirdDecimal = Math.floor((decimal * 1000) % 10)

            return firstDecimal === 9 ||
                secondDecimal === 9 ||
                thirdDecimal >= 5
                ? Math.ceil(price)
                : price
        }

        if (vendor === 'Monica + Andy' && !isInvalidProductType) {
            if (!isDisney) {
                // Check if product is on SALE - these get an ADDITIONAL 40% off
                if (product?.title && product?.title.includes('SALE')) {
                    const compareAtPrice = convertToCurrency(product?.compare_at_price_max);
                    const currentPrice = roundIfNeeded(convertToCurrency(firstVariantWithInventory?.price));

                    // Apply an additional 40% off the already discounted price
                    const additionalDiscountPrice = currentPrice * 0.6; // 40% additional discount

                    setPrice({
                        price: convertToCurrency(product?.price_max),
                        compareAtPrice: compareAtPrice,
                        discountPrice: additionalDiscountPrice,
                    });

                    // Calculate total discount from original compare-at price
                    const totalDiscountAmount = compareAtPrice - additionalDiscountPrice;
                    const totalDiscountPercent = Math.round((totalDiscountAmount / compareAtPrice) * 100);
                    setDiscountPercent(totalDiscountPercent);
                } else {
                    // Regular non-SALE products get standard 40% off
                    setPrice({
                        price: convertToCurrency(product?.price_max),
                        compareAtPrice: convertToCurrency(
                            product?.compare_at_price_max
                        ),
                        discountPrice:
                            convertToCurrency(firstVariantWithInventory?.price) *
                            0.6,
                    });
                    setDiscountPercent(40);
                }
            } else {
                // Disney products - no discount percentage by default
                setPrice({
                    price: convertToCurrency(product?.price_max),
                    compareAtPrice: product?.title.includes('SALE')
                        ? convertToCurrency(product?.compare_at_price_max)
                        : null,
                    discountPrice: null,
                })

                // Explicitly reset discount percent for Disney products
                setDiscountPercent(0)

                // Only set discount percent for SALE Disney products
                if (product?.title.includes('SALE')) {
                    const compareAtPrice = convertToCurrency(
                        product?.compare_at_price_max
                    )
                    const discountedPrice = convertToCurrency(
                        firstVariantWithInventory?.price
                    )

                    const amountOff = compareAtPrice - discountedPrice
                    const discount = Math.round((amountOff / compareAtPrice) * 100)

                    if (discount > 0) {
                        setDiscountPercent(discount)
                    }
                }
            }
        } else if (isUppababySale) {
            // console.log('uppababy sale', product)
            setPrice({
                price: convertToCurrency(product?.price_max),
                compareAtPrice: convertToCurrency(
                    product?.compare_at_price_max
                ),
                discountPrice: null,
            })

            const price = convertToCurrency(product?.price_max)

            const compareAtPrice = convertToCurrency(
                product?.compare_at_price_max
            )
            const discountedPrice = convertToCurrency(
                firstVariantWithInventory?.price
            )

            const amountOff = compareAtPrice - discountedPrice

            const discount = Math.round((amountOff / compareAtPrice) * 100)

            setDiscountPercent(discount)
        }
    }, [
        product,
        firstVariantWithInventory,
        vendor,
        matchingVariants,
        variantIdOnLoad,
    ])

    // if (priceType === 'product') {
    //     console.log('discountPercent', discountPercent)
    // }

    // if (product?.title.includes('Two-Piece Pajama Set')) {
    //     // console.log('price in Price.jsx', price, product?.title)
    // }

    return (
        <div
            className={`price-wrap flex ${
                priceType === 'product' ? 'ml-auto' : ''
            }`}
        >
            {price.price && !isInvalidProductType ? (
                <div className='price-compare-at-price flex'>
                    <div
                        className={`product-price flex items-center ${
                            priceType && priceType === 'product'
                                ? 'justify-end'
                                : ''
                        } lg:flex-nowrap lg:min-w-[210px] ${
                            priceType === 'collectionTile'
                                ? 'text-base font-medium text-flint'
                                : priceType === 'quickBuy'
                                ? 'text-2xl'
                                : 'text-2xl text-right'
                        }`}
                    >
                        {/* {} */}
                        {price.price &&
                        price.discountPrice &&
                        price.discountPrice !== null &&
                        !price.compareAtPrice ? (
                            <Fragment>
                                <span
                                    className={`discounted-price ${
                                        priceType && priceType === 'product'
                                            ? 'text-lg'
                                            : 'text-sm'
                                    }`}
                                >
                                    ${convertToCurrency(price.discountPrice)}
                                </span>
                                <span
                                    className={`ml-1 compare-at-price text-flint/80 line-through discount-compare this-one ${
                                        priceType && priceType === 'product'
                                            ? 'text-base'
                                            : 'text-sm'
                                    }`}
                                >
                                    ${convertToCurrency(price.price)}
                                </span>
                            </Fragment>
                        ) : null}

                        {price.price &&
                        price.discountPrice &&
                        price.discountPrice !== null &&
                        price.compareAtPrice ? (
                            // console.log('price.discountPrice', price.discountPrice)
                            <Fragment>
                                <span
                                    className={`discounted-price ${
                                        priceType && priceType === 'product'
                                            ? 'text-lg'
                                            : 'text-sm'
                                    }`}
                                >
                                    ${convertToCurrency(price.discountPrice)}
                                </span>
                                <span
                                    className={`ml-1 compare-at-price text-red-500 line-through discount-compare ${
                                        priceType && priceType === 'product'
                                            ? 'text-base'
                                            : 'text-sm'
                                    }`}
                                >
                                    ${convertToCurrency(price.compareAtPrice)}
                                </span>
                            </Fragment>
                        ) : null}

                        {!price.discountPrice &&
                        price &&
                        price.price !== 0 &&
                        price.price !== '0' ? (
                            <span className='price this-price'>
                                {/* {console.log(
                                'price in Price.jsx here',
                                price,
                                product?.title
                            )} */}
                                $
                                {convertToCurrency(
                                    price?.price || product?.price_max || price
                                )}
                            </span>
                        ) : null}
                        {!price.discountPrice &&
                        price.compareAtPrice &&
                        price.compareAtPrice !== null &&
                        price.compareAtPrice !== price.price ? (
                            <span className='ml-1 compare-at-price text-red-500 line-through text-sm'>
                                ${convertToCurrency(price.compareAtPrice)}
                            </span>
                        ) : null}
                        {price.price &&
                        !price.discountPrice &&
                        price.compareAtPrice &&
                        price.price !== price.compareAtPrice &&
                        price.discountPrice > 0 &&
                        price.discountPrice < price.compareAtPrice ? (
                            <Fragment>
                                <span className='price'>
                                    ${convertToCurrency(price.discountPrice)}
                                </span>
                                <span className='ml-1 compare-at-price text-flint/80 line-through text-sm'>
                                    ${convertToCurrency(price.compareAtPrice)}
                                </span>
                            </Fragment>
                        ) : null}

                        {(price.price === '0' || price.price === 0) && (
                            <span>Free</span>
                        )}

                        {discountPercent && discountPercent > 0 ? (
                            <span className='inline-flex ml-2 discount-percent text-red-500 font-semibold text-[10px] min-w-[54px]'>
                                {discountPercent}% Off
                            </span>
                        ) : null}
                    </div>
                </div>
            ) : (
                <span className='price invalid-price text-base'>
                    {/* {console.log(
                                'price in Price.jsx here',
                                price,
                                product?.title
                            )} */}
                    {product?.price_min &&
                    product?.price_max &&
                    product?.price_min !== product.price_max ? (
                        <span>
                            $
                            {product?.price_min
                                ? convertToCurrency(product.price_min)
                                : null}{' '}
                            –{' '}
                            {product?.price_max
                                ? convertToCurrency(product.price_max)
                                : null}
                        </span>
                    ) : (
                        <span>
                            $
                            {product?.price_max
                                ? convertToCurrency(product.price_max)
                                : null}
                        </span>
                    )}
                </span>
            )}
        </div>
    )
}

export default Price
